/* ----------------- External Imports --------------- */
import { isWeb } from "@helpers/platform";

/* ----------------- Internal Imports --------------- */

import { events } from "@constants/tracking";
import { useArticles } from "@features/articles/hooks/useArticles";
import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { getDisplayName } from "@helpers/user";
import useAnalytics from "@hooks/useAnalytics";
import { titleCase } from "@memorang/helpers/src/common";
import Box from "@memorang/ui/src/components/Box";
import Loader from "@memorang/ui/src/components/Loader";
import ScrollContainer from "@memorang/ui/src/components/ScrollContainer";
import { useDevice } from "@memorang/ui/src/useDevice";
import CustomAppbar from "components/CustomAppbar";
import ImageChallengeHomeView from "../components/ImageChallengeHomeView";
/* ----------------- Local Imports --------------- */
import { useImageChallengeHome } from "../hooks/useImageChallengeHome";

const ImageChallengeHomeContainer = () => {
	const { featuredChallenge, imageChallengeHomeSectionList, isLoading } =
		useImageChallengeHome();

	const { newUserInfo } = useAuthContext();

	const { explicitCallTrackCustomEvent } = useAnalytics();

	const { isMobile } = useDevice();

	// const showChallengeCountdown = useAppStore(
	// 	(state) => state.app.showChallengeCountdown,
	// );
	const { handleNavigateToArticle } = useArticles();
	const handleClickCard = (id: number, type: string, isFeatured?: boolean) => {
		switch (type) {
			case "article": {
				explicitCallTrackCustomEvent({
					eventName: events.articleClicked,
					articleId: id,
					source: "home",
				});
				handleNavigateToArticle(id);
				break;
			}
			case "challenge": {
				const eventName = isFeatured
					? events.featuredChallengeClicked
					: events.challengeClicked;
				explicitCallTrackCustomEvent({
					eventName,
					challengeId: id,
					source: "home",
				});
				// const challengeItem = flattenItems?.find(
				// 	(item) => item.id === Number(id),
				// );
				// handleCreateFormativeSession({
				// 	challengeItem,
				// 	isFeatured,
				// });
				break;
			}
			default:
				break;
		}
	};

	const getGreeting = () => {
		const currentHour = new Date().getHours();
		if (currentHour < 12) {
			return "☀️ Good morning";
		}
		if (currentHour < 18) {
			return "🌇️ Good afternoon";
		}
		return "🌙 Good evening";
	};

	const greeting = getGreeting();

	const displayName = getDisplayName(
		newUserInfo?.profession,
		newUserInfo?.firstName,
		newUserInfo?.lastName,
	);
	const appbarTitle = displayName
		? `${greeting}, ${titleCase(displayName)}`
		: `${greeting}!`;

	return (
		<>
			<CustomAppbar
				mode="medium"
				align="flex-start"
				showCommandBar={isWeb}
				showHambugerMenu
				options={{
					headerTitle: appbarTitle,
					subtitle: isMobile
						? undefined
						: "Welcome to your personalized dashboard",
				}}
			/>
			<ScrollContainer maxWidth="sm">
				{isLoading ? (
					<Box
						alignItems="center"
						justifyContent="center"
						flexGrow={1}
						height="100%"
					>
						<Loader />
					</Box>
				) : (
					<Box paddingTop={8} paddingBottom={8}>
						<ImageChallengeHomeView
							recommendedChallenge={featuredChallenge}
							isPremiumUser={false}
							imageChallengeHomeSectionList={imageChallengeHomeSectionList}
							handleClickCard={handleClickCard}
							// headerComponent={
							// 	showChallengeCountdown &&
							// 	nextChallenge &&
							// 	nextChallenge.publishedAt ? (
							// 		<ChallengeCountdownContainer
							// 			imageUrl={nextChallenge.imageUri!}
							// 			challengeNumber={nextChallenge.challengeNumber}
							// 			numResponses={nextChallenge.numResponses}
							// 			title={nextChallenge.title}
							// 			publishedAt={nextChallenge.publishedAt}
							// 		/>
							// 	) : null
							// }
						/>
					</Box>
				)}
			</ScrollContainer>
		</>
	);
};

export default ImageChallengeHomeContainer;
